import SimilarProductCarousel from 'components/SimilarProductCarousel/SimilarProductCarousel.f';

export default SimilarProductCarousel;
